var RECENTLY_VIEWED_KEY = 'nexusrig_recently_viewed';
var MAX_RECENTLY_VIEWED = 10;

export function getRecentlyViewed() {
    try {
        var stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch (e) {
        return [];
    }
}

export function addToRecentlyViewed(product) {
    if (!product || !product.id) return;
    try {
        var viewed = getRecentlyViewed();
        viewed = viewed.filter(function(p) { return p.id !== product.id; });
        viewed.unshift({
            id: product.id,
            slug: product.slug,
            name: product.name,
            price: product.price,
            original_price: product.original_price,
            brand: product.brand,
            images: product.images,
            condition: product.condition,
            stock: product.stock,
            specs: product.specs,
            category: product.category,
            subcategory: product.subcategory
        });
        viewed = viewed.slice(0, MAX_RECENTLY_VIEWED);
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
    } catch (e) {
        // localStorage might be full or disabled
    }
}
